
class OperaMappingKeyCell extends UITableViewCell
{
    private nameTextField: MUITextField = null;
    private targetComboBox: MUIComboBox = null;

    // Category names declared by the seed's "category:" rows — set by the VC before item.
    categories: string[] = [];

    awakeFromHTML() {
        this.nameTextField = MUIOutlet(this, "name-tf", "MUITextField");
        this.nameTextField.setOnChangeText(this, function(tf: MUITextField, value: string) {
            this._item.sourceKey = "tag:" + value.trim();
        });

        this.targetComboBox = MUIOutlet(this, "target-cb", "MUIComboBox");
        this.targetComboBox.setOnChangeAction(this, function(cb: MUIComboBox, value: string) {
            this._item.targetKey = value;
        });

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    private _item: IntegratorMappingKey = null;
    set item(item: IntegratorMappingKey) {
        this._item = item;

        let source = item.sourceKey || "";
        this.nameTextField.text = source.indexOf("tag:") == 0 ? source.substring(4) : source;

        this.targetComboBox.removeAllItems();
        for (let c of this.categories) this.targetComboBox.addItem(c, c);
        if (item.targetKey && this.categories.indexOf(item.targetKey) == -1) {
            this.targetComboBox.addItem(item.targetKey, item.targetKey);
        }
        if (item.targetKey) this.targetComboBox.selectItem(item.targetKey);
    }
}
